import { FAVORITES_COLUMN } from '../movies/constants';

export const COLUMN_OPTIONS = [
  { value: 'favoritos', label: 'Favoritos' },
  { value: 'assistidos', label: 'Ja assisti' },
  { value: 'quero-ver', label: 'Quero assistir' },
];

export const CATEGORY_SUGGESTIONS = [
  'series',
  'filmes',
  'animacoes',
  'drama',
  'ficcao-cientifica',
  'suspense',
];

export const INITIAL_FAVORITE_FORM_STATE = {
  title: '',
  column: FAVORITES_COLUMN,
  category: 'filmes',
  note: '',
};
